<template>
    <div class="apkManageList">
        <div class="buttonView">
            <el-button @click="upload" size="mini">上传</el-button>
        </div>
        <div class="tableView" id="tableView">
            <el-table :data="tableData" stripe style="width: 100%;z-index: 1;" :height="tableHeight" v-if="tableHeight">
                <el-table-column prop="apkName" label="App名称" width="180">
                </el-table-column>
                <el-table-column prop="apkVersion" label="版本" width="180">
                </el-table-column>
                <el-table-column prop="build" label="build" width="180">
                </el-table-column>
                <el-table-column prop="apkCreateTime" label="上传时间" width="180">
                </el-table-column>
    
                <el-table-column label="下载地址">
                    <template slot-scope="scope">
                        <div :style="{'height':qrHeight+'px','width':qrWidth+'px'}" >
                            <a :href="scope.row.apkAddress">
                                <QrcodeView :qrid="scope.row.id" :qrContent="scope.row.apkAddress" :qrHeight="qrHeight"
                                    :qrWidth="qrWidth" />
                            </a>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button type="text" @click="deleteApk(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="paginationView">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page.currentPage"
                :page-size="page.size"
                :page-sizes="[10, 20, 30, 40, 50]"
                layout="total, sizes, prev, pager, next"
                :total="page.total"
            >
            </el-pagination>
        </div>
        <el-dialog title="上传" :visible.async="uploadVisible" center width="500px" @close="uploadVisible = false"
            :close-on-click-modal="false">
            <el-form :model="uploadForm" label-width="80px">
                <el-form-item label="Apk">
                    <el-upload class="upload-demo" drag :action="action" :headers="headers" :file-list="uploadForm.fileList"
                        :on-success="onSuccessUpload" :before-upload="beforeAvatarUpload">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="App名称">
                    <el-input v-model="uploadForm.apkName" placeholder="请输入App名称" class="inputView"></el-input>
                </el-form-item>
                <el-form-item label="App版本">
                    <el-input v-model="uploadForm.versionCode" placeholder="请输入版本号" class="inputView"></el-input>
                </el-form-item>
                <el-form-item label="build">
                    <el-input v-model="uploadForm.buildNumber" placeholder="请输入build" class="inputView"></el-input>
                </el-form-item>
            </el-form>
            <div class="saveBtnView">
                <el-button @click="save" style="width:300px" type="primary">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getToken } from "@/utils/auth";
import { saveOrUpdateApk, getApkList, deleteApk } from "@/api/apk";
import QrcodeView from "@/components/qrcode"

const ApkParser = require('app-info-parser/src/apk');

export default {
    components: {
        QrcodeView
    },
    data() {
        return {
            uploadVisible: false,
            action: process.env.VUE_APP_BASE_API + '/message/appversioninfo/upload',
            tableData: [],
            tableHeight: 0,
            uploadForm: {
                fileList: [],
                versionCode: '',
                buildNumber: '',
                apkName: ''
            },
            qrcode: '',
            qrlink: '',
            qrHeight: 70,
            qrWidth: 70,
            page:{
                currentPage:1,
                size:10,
                total:10
            }
        }
    },
    computed: {
        headers: function () {
            return {
                Authorization: "Bearer " + getToken(),
            };
        },
    },
    created() {
        this.getList()
        //获取table的高度
        this.$nextTick(() => {
            let tableHeight = document.getElementById('tableView').offsetHeight;
            console.log('tableHeight', tableHeight);
            
            this.tableHeight = tableHeight
        })
    },
    methods: {
        upload() {
            this.uploadVisible = true

        },
        async save() {
            console.log(this.uploadForm);
            const { fileList, apkName, versionCode, buildNumber } = this.uploadForm
            let obj = {
                "apkAddress": fileList[0],
                "apkName": apkName,
                "apkVersion": versionCode,
                "build": buildNumber
            }
            const resp = await saveOrUpdateApk(obj)
            if (resp) {
                this.uploadVisible = false
                this.getList()
            }

        },
        onSuccessUpload(res, file, fileList) {
            this.uploadForm.fileList = [res.url]
        },
        async getList() {
            let obj = {
                size: this.page.size,
                current: this.page.currentPage
            }
            const resp = await getApkList(obj)
            if (resp && resp.records) {
                const { total, current } = resp
                this.page.total = total
                this.page.currentPage = current
                this.tableData = resp.records
            }
        },
        /**
  * 获取当前文件
  */
        beforeAvatarUpload(file) {
            console.log(file);
            const parser = new ApkParser(file);
            parser
                .parse()
                .then((result) => {
                    // debugger
                    // this.appIcon = result.icon;
                    this.uploadForm.versionCode = result.versionName;
                    this.uploadForm.buildNumber = result.versionCode;
                    // this.appKey = result.package;
                    this.uploadForm.apkName = result.application.label[0];
                    // this.byteSize = file.size / 1024;
                    // let size = file.size; //byte
                    // size = size / 1024; //kb
                    // size = (size / 1024).toFixed(2); //mb
                    // this.appSize = size + 'm';
                    // this.file = file;
                    // this.getFileMD5(file);
                })
                .catch((err) => {

                });
        },
        deleteApk(e) {
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteConfirm(e)
            }).catch(() => {
               
            });
        },
        async deleteConfirm(e){
            const resp = await deleteApk(e.id)
            if (resp) {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.getList()
            }
        },
        handleCurrentChange(e){
            this.getList()
        },
        handleSizeChange(e){
            this.page.currentPage = 1
            this.page.size = e
            this.getList()
        }
    }
}
</script>
<style lang="scss" scoped>
.apkManageList {
    padding: 24px;
    background-color: #fff;
    height: 100%;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    .uploadView {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .inputView {
        width: 360px;
    }

    .saveBtnView {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .pop {
        width: 300px;
        height: 400px;
        background-color: rgb(20, 22, 26);
        border-radius: 8px;
        position: absolute;
        left: 0px;
        top: 0px;
        z-index: 999;
    }
    .tableView{
        display: flex;
        flex: 1;
    }
    .paginationView{
        margin-top: auto;
        display: flex;
        justify-content: flex-end;
    }
    .buttonView{
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
}</style>